import React from 'react';
import { Box, keyframes } from '@mui/material';

const version = '?v=5';

const scrollLeft = keyframes`
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(-50%);
    }
`;

const scrollRight = keyframes`
    0% {
        transform: translateX(-50%);
    }
    100% {
        transform: translateX(0);
    }
`;

function companyImg(src, index) {
    return (
        <img
            style={{ height: '56px', width: 'auto', objectFit: 'contain', filter: 'grayscale(1)', opacity: 0.62 }}
            src={src.img.replace('.webp', '_c.webp').concat(version)}
            alt={`${src.title} usa POK para credenciales digitales verificables`}
            loading="lazy"
            key={index}
        />
    );
}

const InfiniteCarousel = ({ images, reverse }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                maskImage: 'linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent)',
                WebkitMaskImage: 'linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent)',
            }}
        >
            <Box
                className={`carousel-track ${reverse ? 'reverse' : ''}`}
                sx={{
                    display: 'inline-flex',
                    animation: `${scrollLeft} 240s linear infinite`,
                    '&.reverse': {
                        animation: `${scrollRight} 240s linear infinite`,
                    },
                }}
            >
                {/* We need to repeat the images twice to create the infinite effect, because the animation
                    resets before a least all logos have been shown once
                */}
                {images.concat(images).map((src, index) => (
                    <Box
                        key={index}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            height: 64,
                            paddingX: '28px',
                        }}
                    >
                        {src?.linkOnCarrousel ? (
                            <a href={src.url} target={'_blank'} rel="noopener">
                                {companyImg(src, index)}
                            </a>
                        ) : (
                            companyImg(src, index)
                        )}
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default InfiniteCarousel;
